import { computed, type ComputedRef } from 'vue'

/**
 * Visibility flags for CPRootContainer sidebar and content.
 * Account settings (desktop): portal sidebar is always forced collapsed (icon-only, 3rem) so the
 * account settings content gets the full width. The collapse toggle is hidden on this route,
 * so users cannot expand the sidebar while in account settings. On navigation away the sidebar
 * restores to whatever the user's previous collapsed/expanded state was.
 * Account settings (mobile): no portal drawer; dedicated TopBarMobile handles this route.
 */
export function useCPRootVisibility(
  isNonCPNavigationRoute: ComputedRef<boolean>,
  isMobile: { value: boolean },
  isAuthPage: ComputedRef<boolean>,
  isAccountSettingsPage: ComputedRef<boolean>
) {
  const showPortalSidebar = computed(() => !isMobile.value && !isAuthPage.value)

  const showSidebarToggleBar = computed(
    () => !isNonCPNavigationRoute.value && !isMobile.value && !isAuthPage.value && !isAccountSettingsPage.value
  )

  const showPortalMobileDrawer = computed(() => isMobile.value && !isAuthPage.value && !isAccountSettingsPage.value)

  const showTopBar = computed(() => !isMobile.value && !isAuthPage.value)

  const showMobileTopBar = computed(() => isMobile.value && !isAuthPage.value)

  return {
    showPortalSidebar,
    showSidebarToggleBar,
    showPortalMobileDrawer,
    showTopBar,
    showMobileTopBar,
  }
}
